/**
 * 失败原因二级分类（P1-12，画布保存失败复用）
 *
 * 背景：后端业务错误码已有 14+ 个（见 src/utils/request.ts），若 failReason 直接取
 * 原始 code，加上 network/timeout/offline 等，取值数会逼近甚至超过 Top20 —— 冷门错误码
 * 被挤出看板，而冷门恰恰是新出现的、最该被注意的故障（详见方案补遗三 C.4）。
 *
 * 做法：粗粒度分类进 categories（≤8 个取值，看板永远完整可读），精确错误码走 sendLog
 * 的 content（供单条排查时查看），不作维度。
 */

interface ClassifiableError {
  code?: number | string;
  name?: string;
  message?: string;
}

/** 固定 8 个取值：offline / timeout / network / auth / server / client / quota / other */
export function classifyFailReason(err: unknown): string {
  if (typeof navigator !== 'undefined' && navigator.onLine === false) return 'offline';

  const e = (err ?? {}) as ClassifiableError;
  if (e.name === 'ECONNABORTED' || e.message?.toLowerCase().includes('timeout')) return 'timeout';

  const code = typeof e.code === 'number' ? e.code : undefined;
  if (code === undefined) return 'network';
  if (code === 400001 || code === 400002 || code === 401) return 'auth';
  if (code >= 500000 && code < 600000) return 'server';
  if (code >= 400000 && code < 500000) return 'client';
  if (code >= 600000) return 'quota';
  return 'other';
}
